import { render, staticRenderFns } from "./Flashcard.vue?vue&type=template&id=ed29c0ce&scoped=true&lang=pug"
import script from "./Flashcard.vue?vue&type=script&lang=ts"
export * from "./Flashcard.vue?vue&type=script&lang=ts"
import style0 from "./Flashcard.vue?vue&type=style&index=0&id=ed29c0ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed29c0ce",
  null
  
)

export default component.exports